<script setup>
import { Head, useForm } from "@inertiajs/vue3";
import { ref, watch } from "vue";

import VDevider from "@/Shared/VDevider.vue";
import VAlert from "@/Shared/VAlert.vue";
import VFormOutbound from "@/Pages/PublicPage/Survey/_partials/VFormOutbound.vue";
import VFormDeparting from "@/Pages/PublicPage/Survey/_partials/VFormDeparting.vue";
import VTab from "@/Pages/PublicPage/Survey/_partials/VTab.vue";

import { listTabDepartingVisitor, listTabSabahOutbound } from "../tabs.config";

const props = defineProps({
    additional: Object,
});

const { formType, urlSubmit, survey, answers, surveyFields } = props.additional;

const TYPE_SURVEY_DEPARTING = "departing-visitor-survey";
const TYPE_SURVEY_OUTBOUND = "sabah-outbound-survey";

const tabs =
    survey.code == TYPE_SURVEY_DEPARTING
        ? listTabDepartingVisitor
        : listTabSabahOutbound;

const currentTabIndex = ref(0);
const currentTab = ref(tabs[0]);
const currentTabKey = ref(currentTab.value.key);

const form = useForm(answers);

tabs.map((item) => {
    item.status = 1;
    return item;
});

watch(currentTabKey, (newValue) => {
    currentTab.value = tabs.find((item) => item.key == newValue);
});

const handleOnNext = async (data) => {
    const currentIndex = tabs.findIndex(
        (item) => item.key == currentTab.value.key
    );
    let submitData = { ...answers };
    for (const prop in data) {
        submitData[prop] = data[prop];
    }

    submitData.isLast = currentIndex == tabs.length - 1;
    submitData._method = formType;
    form.transform(() => submitData).post(urlSubmit, {
        preserveScroll: true,
        onSuccess: () => {
            tabs[currentIndex].status = 2;
            const tab = tabs[currentIndex + 1] ?? tabs[tabs.length - 1];
            tab.status = 1;
            currentTab.value = tab;
            currentTabKey.value = currentTab.value.key;
        },
    });
};
</script>

<template>
    <div class="row">
        <div class="col-12 col-md-3">
            <VTab :tabs="tabs" v-model:value="currentTabKey"></VTab>
        </div>
        <div class="col-12 col-md-9">
            <div class="card">
                <div class="card-body">
                    <component
                        :is="
                            survey.code == TYPE_SURVEY_DEPARTING
                                ? VFormDeparting
                                : VFormOutbound
                        "
                        :tab="currentTab"
                        :survey="survey"
                        :answers="answers"
                        :surveyFields="surveyFields"
                        @onNext="handleOnNext"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
